// components/LoginHandler.js - Handles post-login data loading
import React, { useState, useEffect } from 'react';
import { Sprout } from 'lucide-react';
import { Card, GardenBackground } from '../components/ui';

export const LoginHandler = ({ loginData, onComplete, onError }) => {
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(0);
  const [currentStep, setCurrentStep] = useState('Loading family data...');

    const API_BASE_URL = 'https://growthsprouts-server.vercel.app/api';


  useEffect(() => {
    const loadFamilyData = async () => {
      try {
        setProgress(20);
        setCurrentStep('Loading family information...');
        
        // Extract data from login response
        const { user, guardian, family } = loginData;
        
        setProgress(40);
        setCurrentStep('Loading children...');
        
        // Load children for the family
        const childrenResponse = await fetch(`${API_BASE_URL}/families/${family.id}/children`);
        const childrenResult = await childrenResponse.json();
        
        setProgress(60);
        setCurrentStep('Loading family guardians...');
        
        // For now, we'll just use the current guardian
        // In a real app, you might load all guardians for the family
        const guardians = [guardian];
        
        setProgress(80);
        setCurrentStep('Finalizing...');
        
        // Prepare complete family data
        const completeData = {
          user,
          guardian,
          family,
          children: childrenResult.success ? childrenResult.data : [],
          guardians
        };
        
        setProgress(100);
        setCurrentStep('Complete!');
        
        // Small delay for smooth UX
        setTimeout(() => {
          onComplete(completeData);
        }, 500);
        
      } catch (error) {
        console.error('LoginHandler: Error loading family data:', error);
        onError(error.message || 'Failed to load family data');
      }
    };

    if (loginData) {
      loadFamilyData();
    }
  }, [loginData, onComplete, onError]);

  return (
    <div className="min-h-screen relative flex items-center justify-center p-4">
      <GardenBackground />
      <Card className="w-full max-w-md p-8 relative z-10 text-center">
        <div className="mb-8">
          <div className="flex justify-center mb-4">
            <img src="/logo.svg" alt="GrowthSprouts" className="w-16 h-16" />
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Welcome Back!</h2>
          <p className="text-gray-600">Setting up your family garden...</p>
        </div>

        <div className="space-y-4">
          {/* Progress Bar */}
          <div className="w-full bg-gray-200 rounded-full h-3">
            <div 
              className="bg-green-500 h-3 rounded-full transition-all duration-300 ease-out"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          
          {/* Current Step */}
          <p className="text-sm text-gray-600">{currentStep}</p>
          
          {/* Progress Percentage */}
          <p className="text-xs text-gray-500">{progress}% complete</p>
        </div>
      </Card>
    </div>
  );
};